import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyRefrigerantUsage, setFootprintingDairyRefrigerantUsageAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_REFRIGERANT_USAGE } from "consts";

import { UploadableRefrigerant } from "models";

export const useMutateFootprintingDairyRefrigerantUsage = (farmId: string, year: number, payload: UploadableRefrigerant[], primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_REFRIGERANT_USAGE, primaryDataId, isAdmin],
      mutationFn: () =>
        isAdmin ? setFootprintingDairyRefrigerantUsageAdmin(payload, primaryDataId) : setFootprintingDairyRefrigerantUsage(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_REFRIGERANT_USAGE, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
